import withStore, {
  TPresentable,
  TLoadingAwarePresenter
} from "../../core/presenter/withStore";
import Application from "../../Application";
import { IUser } from "../../user/model/User";
import { IOrganisation } from "../../organisations/model/Organisation";
import { IOrganisationIndexCategory } from "../../organisations/model/OrganisationIndexCategory";
import GetIndexHarmonizationReportInteractor from "../interactor/GetIndexHarmonizationReportInteractor";
import GetAllOrganisationIndexCategoriesInteractor from "../../organisations/interactors/GetAllOrganisationIndexCategoriesInteractor";
import { IIndexHarmonizationReportItem } from "../model/IndexHarmonizationReportItem";
import moment from "moment";
import GetAllIndexTypeCategoriesInteractor from "../../indexTypes/interactors/GetAllIndexTypeCategoriesInteractor";
import { IIndexTypeCategory } from "../../indexTypes/model/IndexTypeCategory";

export interface TOrganisationIndexByDateReportPresenter
  extends TLoadingAwarePresenter {
  user?: IUser;
  organisationIds?: number[];
  organisations: IOrganisation[];
  indexCategories: IIndexTypeCategory[];
  dateIncluded?: Date;
  selectedCategoryId: number;
  data: IIndexHarmonizationReportItem[];
  fromDate?: Date;
  toDate?: Date;
}

export interface IOrganisationIndexByDateReportPresenter
  extends TOrganisationIndexByDateReportPresenter,
    TPresentable {
  loadReferenceValues(organisations: IOrganisation[]): void;
  setDateIncluded(dateIncluded: Date): void;
  setOrganisationIds(organisationId: number[]): void;
  setCategoryId(categoryId: number): void;
  onChangeDateRange(fromDate: Date, toDate: Date): void;
}

const defaultState: TOrganisationIndexByDateReportPresenter = {
  selectedCategoryId: NaN,
  organisations: [],
  indexCategories: [],
  dateIncluded: undefined,
  data: [],
  toDate: new Date(),
  fromDate: moment().subtract(1, "months").toDate()
};

const OrganisationIndexByDateReportPresenter = withStore<
  IOrganisationIndexByDateReportPresenter,
  TOrganisationIndexByDateReportPresenter
>(
  ({
    application,
    store,
    loader,
    translate
  }): IOrganisationIndexByDateReportPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<
      TOrganisationIndexByDateReportPresenter & TLoadingAwarePresenter
    >();
    loader.start("projectLoader");
    const loadReferenceValues = (organisations: IOrganisation[]) => {
      const user = _store.getState<any>().user;
      _store.update({ organisations, user });
      getIndexCategories();
      loader.stop("projectLoader");
      loader.stop("reportLoader");
    };

    const getIndexCategories = async () => {
      let data = await _application.container
        .resolve<GetAllIndexTypeCategoriesInteractor>(
          "getAllIndexTypeCategories"
        )
        .execute();
      _store.update({
        indexCategories: data,
        selectedCategoryId: undefined,
        data: undefined
      });
    };
    const setDateIncluded = (dateIncluded: Date) => {
      _store.update({ dateIncluded, data: undefined });
    };
    const setCategoryId = (categoryId: number) => {
      _store.update({ selectedCategoryId: categoryId, data: undefined });
    };
    const setOrganisationIds = (organisationIds: number[]) => {
      _store.update({ organisationIds, data: undefined });
    };

    const onChangeDateRange = (fromDate: Date, toDate: Date) => {
      _store.update({
        fromDate,
        toDate
      });
    };
    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      loadReferenceValues,
      setDateIncluded,
      setOrganisationIds,
      setCategoryId,
      onChangeDateRange
    };
  },
  defaultState
);

export default OrganisationIndexByDateReportPresenter;
